<kendo-grid [data]="documents" scrollable="virtual" class="kendo-grid-doc">

  <kendo-grid-column field="documentName">
    <ng-template kendoGridHeaderTemplate let-column>
      <span>Document Name</span>
    </ng-template>
    <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
      <a class="doc-name" (click)="viewDocument(row)"> {{row.documentName}} </a>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="uploadDate" title="Upload Date">
    <ng-template kendoGridCellTemplate let-column>
      {{column.uploadDate | date: 'MM/dd/yyyy'}}
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="uploadedBy">
    <ng-template kendoGridHeaderTemplate let-column>
      <span>Uploaded By</span>
    </ng-template>
    <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
      <a class="doc"> {{ row.uploadedBy}} </a>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="documentType" *ngIf="editMode">
    <ng-template kendoGridHeaderTemplate let-column>
      <span>Action</span>
    </ng-template>
    <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
      <div class="action-btn-container">
        <button kendoButton data-testid="delete-button" *ngIf="editMode && hasPermissionDeleteDoc" title="Delete"
          [disabled]="status" [svgIcon]="trashIcon" themeColor="error" fillMode="outline"
          (click)="confirmDelete(row)"></button>
        <button kendoButton [svgIcon]="downloadIcon" (click)="downloadDocument(row)" title="Download"></button>
      </div>
    </ng-template>
  </kendo-grid-column>

</kendo-grid>
<div kendoDialogContainer></div>